var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ReadyEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { DIGIT_INPUTS_MAX_SIZE } from './digit-inputs-constants.js';
import { getValue } from './digit-inputs-utils.js';
class DigitInputsAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onReady = new ReadyEventListener();
    }
    clear() {
        const valueMap = new Map();
        for (let index = 0; index < DIGIT_INPUTS_MAX_SIZE; index++) {
            valueMap.set(index, '');
        }
        this.setState({ valueMap });
    }
    getEnabled() {
        return this.state.enabled;
    }
    setEnabled(enabled) {
        this.setState({ enabled });
    }
    getDigits() {
        return this.state.digits;
    }
    setDigits(digits) {
        this.setState({ digits });
    }
    isReadOnly() {
        return this.state.readOnly;
    }
    setReadOnly(readOnly) {
        this.setState({ readOnly });
    }
    getType() {
        return this.state.type;
    }
    setType(type) {
        this.setState({ type });
    }
    getValue() {
        return getValue(this.state.valueMap, this.state.digits);
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], DigitInputsAPI.prototype, "onReady", void 0);
export default DigitInputsAPI;
//# sourceMappingURL=digit-inputs-api.js.map